import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import { PageHeader } from '@ui/Table/Header/PageHeader'

import { ScrollToIds } from '@hooks/useScrollToElementIds'

import styles from './IBSignUpPage.module.scss'

export const IBSignUpPage: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation()

  return (
    <div id={ScrollToIds.IBSignupContainer} className={styles.ibSignupPage}>
      <PageHeader title={t('IB.Introducing Broker Program')} id={ScrollToIds.IBProfileHeader} />

      <div className={styles.container}>{children ? children : <Outlet />}</div>
    </div>
  )
}
